"use client"
import { Box, Typography } from "@mui/material"
import { Desktop, Mobile } from "common/MediaQueries"
import usePrivacyPolicyLink from "hooks/usePrivacyPolicyLink"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { StyledSvgIcon } from "theme/shared"

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
  z-index: 1000;
  background: #020202;
  padding: 30px 40px;
  border-top: 1px solid var(--Direct-Grey, #6f6f6f);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 13px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: flex-start;
    gap: 20px;
    padding: 20px;
    width: 100%;
  }
`

const StyledCloseButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`

const StyledContentContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: flex-start;
    gap: 8px;
  }
`

const StyledContent = styled(Typography)`
  color: var(--Black, #1f1f1f);
  font-weight: 300;
  font-style: Light;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: right;
  vertical-align: middle;
  color: var(--Direct-White, #ffffff);

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-weight: 300;
    font-style: Light;
    font-size: 14px;
    line-height: 24px;
  }
`

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const hasBeenDismissed = localStorage.getItem("cookieBannerDismissed")
    if (!hasBeenDismissed) {
      setIsVisible(true)
    }
  }, [])

  const handleDismiss = () => {
    setIsVisible(false)
    localStorage.setItem("cookieBannerDismissed", "true")
    // Set expiration for 6 months (in milliseconds)
    const expirationDate = new Date()
    expirationDate.setDate(expirationDate.getDate() + 30 * 6)
    localStorage.setItem(
      "cookieBannerDismissedExpiry",
      expirationDate.toISOString()
    )
  }
  const privacyPolicyLink = usePrivacyPolicyLink()
  const text = `האתר עושה שימוש בעוגיות כדי לשפר את חוויית הגלישה שלך, להציג תכנים מותאמים אישית ועוד. למידע נוסף אנא קראו את מדיניות הפרטיות שלנו.`
  const textWithLink = text.replace(
    "מדיניות הפרטיות",
    `<a href="${privacyPolicyLink}" target="_blank" style="color:inherit; text-decoration:underline;">מדיניות הפרטיות</a>`
  )

  if (isVisible) {
    return (
      <StyledContainer>
        <StyledContentContainer>
          <Desktop>
            <StyledSvgIcon
              src="/icons/cookie-icon.svg"
              $w={40}
              $h={40}
              style={{ minWidth: "40px" }}
            />
          </Desktop>
          <Mobile>
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <StyledCloseButton onClick={handleDismiss}>
                <StyledSvgIcon
                  src="/icons/XIcon.svg"
                  alt="close"
                  $w={24}
                  $h={24}
                  style={{ minWidth: "24px" }}
                />
              </StyledCloseButton>
              <StyledSvgIcon
                src="/icons/cookie-icon.svg"
                $w={40}
                $h={40}
                style={{ minWidth: "40px" }}
              />
            </Box>
          </Mobile>
          <StyledContent dangerouslySetInnerHTML={{ __html: textWithLink }} />
        </StyledContentContainer>
        <Desktop>
          <StyledCloseButton onClick={handleDismiss}>
            <StyledSvgIcon
              src="/icons/XIcon.svg"
              alt="close"
              $w={24}
              $h={24}
              style={{ minWidth: "24px" }}
            />
          </StyledCloseButton>
        </Desktop>
      </StyledContainer>
    )
  } else {
    return null
  }
}
export default CookieBanner
